'use strict'

export const FONT = {
  SourceSans: [{
    url: ''
  }]
}

export const FONT_FAMILY = {
  system: {
    value: ['"Helvetica Neue"', 'Helvetica', 'Arial'],
    type: 'sans-serif'
  }
}
